package kz.dentalcrm.app.navigation

import org.koin.dsl.module

/**
 * Koin module for navigation components.
 * Provides singleton instances of Navigator and NavigationResults.
 */
val navigationModule = module {
    single<AppNavigator> { ComposeNavigator() }
    single<NavigationResults> { NavigationResultStore() }
}
